export default {
    updateArrayOfItems (context, {srcArray, targetArray}){
        if(!(srcArray instanceof Array) && !(targetArray instanceof Array)){
            console.warn('NO MODIFICATION DONE. PARAMETER MUST BE AN OBJECT WITH KEYS srcArray AND targetArray WICH MUST BE ARRAY');
            return srcArray;
        }
        let srcItemToDestroyIndex = [];
        let targetItemFound = [];
        for(let item of srcArray){
            let targetItem = targetArray.find((targetItem) => targetItem.uid === item.uid);
            if(!targetItem){
                // then an index to srcItemToDestroyIndex array
                srcItemToDestroyIndex.push(srcArray.findIndex((_item) => _item.uid === item.uid));
            }else{
                for (let key in item){
                    if(typeof targetItem[key] === 'object'){
                        if(JSON.stringify(targetItem[key]) === JSON.stringify(item[key])){
                            continue;
                        }else{
                            Vue.set(item, key, targetItem[key]);
                        }
                    }else{
                        item[key] = targetItem[key];
                    }
                }
                targetItemFound.push(targetItem.uid);
            }
        }
        // reverse array for avoid to mess up the index
        srcItemToDestroyIndex = srcItemToDestroyIndex.reverse();
        // destroy items is srcArray not in targetArray
        for(let index of srcItemToDestroyIndex){
            srcArray.splice(index, 1);
        }

        // add new item to srcArray
        for( let item of targetArray){
            if(!targetItemFound.includes(item.uid)){
                srcArray.push(item);
            }
        }
        return srcArray;
    },
    awaitCreationRequest(context, url) {
        let intervalId = '';
        let instanceCreatedUid = '';
        let modelCreated = '';
        return new Promise((resolve, reject) => {
            intervalId = window.setInterval(() => {
                if (instanceCreatedUid === '') {
                    this.axios.get(url).then(creationRequest => {
                        if (creationRequest.data.status === 'FAILED') {
                            window.clearInterval(intervalId);
                            reject();
                        }
                        else if (creationRequest.data.status === 'COMPLETED') {
                            instanceCreatedUid = creationRequest.data.instance_id;
                            modelCreated = creationRequest.data.model_name;
                        }
                    });
                }
                else {
                    this.axios.get(`${window.config.api_root_url}/${modelCreated}/${instanceCreatedUid}/`).then(objectCreated => {
                        if (objectCreated.data.status === 'FAILED') {
                            window.clearInterval(intervalId);
                            reject();
                        }
                        else if (objectCreated.data.status === 'COMPLETED') {
                            window.clearInterval(intervalId);
                            resolve(objectCreated);
                        }
                    });
                }
            }, 2000);
        });
    },
    storeSelectedFactory(context, selectedFactory){
        localStorage.setItem('selectedFactory', selectedFactory.uid);
        this.commit('SET_SELECTED_FACTORY', selectedFactory.uid)
    }
}



// WEBPACK FOOTER //
// ./src/store/actions.js